import { render, staticRenderFns } from "./CoAdminMembersBulkCreate.vue?vue&type=template&id=0b5c9763&"
import script from "./CoAdminMembersBulkCreate.vue?vue&type=script&lang=ts&"
export * from "./CoAdminMembersBulkCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports